import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";
import 'typeface-fira-sans'
import 'typeface-poppins'
deckDeckGoHighlightElement();
require('katex/dist/katex.min.css')